/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { AttachmentDto } from '../../models/attachment-dto';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface GetAttachmentsByRecourseBooking$Params {
  recourceBookingId: number;
}

export function getAttachmentsByRecourseBooking(
  http: HttpClient,
  rootUrl: string,
  params: GetAttachmentsByRecourseBooking$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<AttachmentDto>>> {
  const rb = new RequestBuilder(rootUrl, getAttachmentsByRecourseBooking.PATH, 'get');
  if (params) {
    rb.path('recourceBookingId', params.recourceBookingId, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AttachmentDto>>;
    }),
  );
}

getAttachmentsByRecourseBooking.PATH = '/service/v1/attachment/recoursebooking/{recourceBookingId}';
